import { classNames } from "helpers/ClassNameHelper";
import * as React from "react";
import { CSSProperties } from "react";

export type ButtonVariants =
    | "primary"
    | "secondary"
    | "warning"
    | "primary-ghost"
    | "secondary-ghost"
    | "warning-ghost";

export type ButtonSizes = "large" | "medium" | "small" | "xsmall" | "xxsmall";

interface Props {
    variant?: ButtonVariants;
    type?: "button" | "submit" | "reset";
    className?: string;
    size: ButtonSizes;
    width?: "standard" | "narrow" | "wide";
    style?: CSSProperties;
    disabled?: boolean;
    to?: string;
    isIcon?: boolean;
    lowVision?: boolean;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const Button: React.FC<Props> = ({
    children,
    variant,
    type,
    className,
    size,
    width,
    style,
    disabled,
    isIcon,
    to,
    lowVision,
    onClick,
}) => {
    const getButtonSize = () => {
        return `btn--${size}`;
    };

    const getButtonVariant = () => {
        switch (variant) {
            case "primary":
                return "btn--primary";
            case "secondary":
                return "btn--secondary";
            case "primary-ghost":
                return "btn--primary--ghost";
            case "secondary-ghost":
                return "btn--secondary--ghost";
            case "warning-ghost":
                return "btn--warning--ghost";
            case "warning":
                return "btn--warning";
            default:
                return undefined;
        }
    };

    const commonClasses = classNames(
        "btn",
        getButtonSize(),
        getButtonVariant(),
        lowVision && "btn--low--vision",
        disabled && "btn--disabled",
        className,
        isIcon && "btn--icon",
        width && `btn--${width}`
    );

    return to ? (
        <a href={to} rel="noreferrer" style={style} target="_blank" className={commonClasses}>
            {children}
        </a>
    ) : (
        <button
            type={type}
            style={style}
            className={commonClasses}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};
